﻿$.fn.dxCtrlCalendarInterval = function custom_dxCtrlCalendarInterval(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcalendarinterval");
        this.instance = new cdxCtrlCalendarInterval(this, option);
    }
    return this;
}

window.cdxCtrlCalendarInterval = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (!option.lstDateOccup) option.lstDateOccup = []

    var dx = null
    function mConstruit() {
        container.empty();
        container.css("text-align", "center")

        option.lstDateOccup.forEach(function (dats) {
            dats.date_debut = new Date(dats.date_debut.getFullYear(), dats.date_debut.getMonth(), dats.date_debut.getDate());
            dats.date_fin = new Date(dats.date_fin.getFullYear(), dats.date_fin.getMonth(), dats.date_fin.getDate());
        })

        var opt = {
            width: option.width,
            height: option.height,
            value: (option.selectedDates ? option.selectedDates.date_debut : (option.value ? option.value : new Date())),
            min: (option.min ? option.min : (new Date()).addDays(-1)),
            onValueChanged: function (e) {
                if (!e.value) return
                if (!option.selectedDates) {
                    option.selectedDates = {
                        date_debut: e.value,
                        date_fin: (new Date(e.value)).addDays(1)
                    }
                } else {
                    if (option.selectedDates.date_debut.toDDMMAA() == e.value.toDDMMAA()) {
                        //on a cliqué sur la date début
                        option.selectedDates.date_fin = (new Date(option.selectedDates.date_debut)).addDays(1)
                    } else if (option.selectedDates.date_fin.toDDMMAA() == e.value.toDDMMAA()) {
                        //on a cliqué sur la date de fin
                        if (Me.isLibre(e.value)) {
                            //le jour est libre
                            option.selectedDates.date_debut = e.value
                            option.selectedDates.date_fin = (new Date(e.value)).addDays(1)
                        } else {
                            option.selectedDates.date_debut = (new Date(e.value)).addDays(-1)
                            option.selectedDates.date_fin = (new Date(e.value)).addDays(1)
                        }
                    } else if (e.value > option.selectedDates.date_debut && e.value < option.selectedDates.date_fin) {
                        //on est entre les dates selected
                        //dans les selected dates, on charche la date la plus proche
                        if (diffdate(option.selectedDates.date_debut, e.value, "d") < diffdate(e.value, option.selectedDates.date_fin, "d")) {
                            //plus prés de date_fin
                            option.selectedDates.date_fin = e.value
                        } else {
                            //plus prés de date_debut
                            option.selectedDates.date_debut = e.value
                        }
                    } else if (e.value > option.selectedDates.date_fin) {
                        //aprés la date fin
                        if (mHasDateOccupe(option.selectedDates.date_debut, e.value)) {
                            //on des dates occupé entre la date_debut et la date saisie
                            option.selectedDates.date_debut = e.value
                            option.selectedDates.date_fin = (new Date(e.value)).addDays(1)
                        } else {
                            option.selectedDates.date_fin = e.value
                        }
                    } else if (e.value < option.selectedDates.date_debut) {
                        //avant la date début
                        if (mHasDateOccupe(e.value, option.selectedDates.date_debut)) {
                            //on des dates occupé entre la date saisie et la date_debut
                            option.selectedDates.date_debut = e.value
                            option.selectedDates.date_fin = (new Date(e.value)).addDays(1)
                        } else {
                            //option.selectedDates.date_fin = option.selectedDates.date_debut
                            option.selectedDates.date_debut = e.value
                        }
                    }
                }
                e.component.repaint()
                if (option.onValueChanged) option.onValueChanged({ selectedDates: option.selectedDates })
            },
            onContentReady: function (e) {
                e.component.option("value", null)
                if (typeof option.onContentReady != 'undefined') option.onContentReady(e)
            }
        }
        opt.disabledDates = function (e) {
            return !Me.isLibre(e.date)
        }
        opt.cellTemplate = function (itemDataCell) {
            var $Div = $("<div/>").dxCtrlCalendarCellTemplate({
                itemDataCell: itemDataCell,
                lstDateOccup: option.lstDateOccup,
                showVacances: option.showVacances,
                selectedDates:option.selectedDates
            })
            if (option.cellTemplate) option.cellTemplate(itemDataCell, $Div)
            return $Div
        }
        dx = $("<div style='display:inline-flex'/>").appendTo(container).dxCalendar(opt)
    }

    function mHasDateOccupe(date1, date2) {
        let d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        let d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

        return option.lstDateOccup.filter(function (dats) {
            return dats.date_debut < d2 && dats.date_fin > d1;
        }).length > 0
    }

    this.isLibre = function (dat) {
        var datRef = new Date(dat.getFullYear(), dat.getMonth(), dat.getDate());
        return option.lstDateOccup.filter(function (dats) {
            //return (datRef >= dats.date_debut && datRef < dats.date_fin)
            return (datRef > dats.date_debut && datRef < dats.date_fin)
        }).length == 0
    }

    function mTemplateCell(itemDataCell) {
        var $DivCell = $("<div/>")
        $DivCell.addClass("state_hover")
        $DivCell.css({
            "width": "100%",
            "height": "100%",
            "position": "relative",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "text-align": "center",
            "opacity": "1",
            "border": "1px solid " + theme.color.replace("rgb(", "rgba(").replace(")", ",0.1)")
        })
        var $DivDate = $("<div style='z-index:3;position:absolute;border-radius:50%;padding:2px;font-size:150%;font-weight:bold;' class='numday popsoft'></div>").appendTo($DivCell)

        switch (itemDataCell.view) {
            case "month":
                $DivDate.text(itemDataCell.date.getDate())
                //style aujourd'hui
                if (itemDataCell.date.getFullYear() == (new Date()).getFullYear() && itemDataCell.date.getMonth() == (new Date()).getMonth() && itemDataCell.date.getDate() == (new Date()).getDate()) {
                    $DivDate.css({
                        "border": "3px solid " + theme.backgroundcolorAccent
                    })
                }
                break;
        }

        $DivCell.attr("title", (Me.isLibre(itemDataCell.date) ? "Ouvert" : "Complet"))
        window.setTimeout(function () {
            //affichage jour bloqué
            if (!Me.isLibre(itemDataCell.date)) {
                $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:0 0 " + $DivCell.innerHeight() + "px " + $DivCell.innerWidth() + "px;border-color: transparent transparent #ff8080 transparent;opacity:0.8;'/>").appendTo($DivCell)
            }
            var dateBefore = (new Date(itemDataCell.date)).addDays(-1)
            if (!Me.isLibre(dateBefore)) {
                $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:" + $DivCell.innerHeight() + "px " + $DivCell.innerWidth() + "px 0 0;border-color: #ff8080 transparent transparent transparent;opacity:0.8;'/>").appendTo($DivCell)
            }

            //affichage selected dates
            if (option.selectedDates) {
                if (option.selectedDates.date_debut && option.selectedDates.date_debut.toDDMMMAA() == itemDataCell.date.toDDMMMAA()) {
                    $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:0 0 " + $DivCell.innerHeight() + "px " + $DivCell.innerWidth() + "px;border-color: transparent transparent #5aff58 transparent;opacity:0.5;'/>").appendTo($DivCell)
                } else if (option.selectedDates.date_fin && option.selectedDates.date_fin.toDDMMMAA() == itemDataCell.date.toDDMMMAA()) {
                    $("<div style='position:absolute;bottom:0px;left:0px;width:0;height:0;border-style:solid;border-width:" + $DivCell.innerHeight() + "px " + $DivCell.innerWidth() + "px 0 0;border-color: #5aff58 transparent transparent transparent;opacity:0.5;'/>").appendTo($DivCell)
                } else if (option.selectedDates.date_debut != null && option.selectedDates.date_fin != null && option.selectedDates.date_fin && itemDataCell.date >= option.selectedDates.date_debut && itemDataCell.date <= option.selectedDates.date_fin) {
                    $("<div style='position:absolute;bottom:0px;left:0px;height:100%;width:100%;background-color:#5aff58;opacity:0.5;'/>").appendTo($DivCell)
                }
            }
        }, 0)

        //affichage vacances
        if (option.showVacances) mShowVacances(itemDataCell, $DivCell)

        return $DivCell
    }

    this.element = function () { return container }
    this.component = function () { return dx }

    mConstruit();
}

window.mShowVacances = function(itemDataCell, contentElement) {
    var libVac = parametre.vacances.mGetLibelleZone(itemDataCell.date)
    if (libVac.length > 0) {
        $("<div style='position:absolute;top:1px;left:2px;font-size:60%;opacity:0.5;z-index:2'>" + libVac + "</div>").appendTo(contentElement)
        contentElement.css("background-color", theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.2)"))
    }
    var jourFerie = parametre.joursFeries.getIsDateFerie(itemDataCell.date)
    if (jourFerie) {
        contentElement.css("background-color", theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.4)"))
    }
}